
import NotificationAPI from '@/services/notifications/notificationsAPI'
import UserAPI from "@/services/user/userAPI"

/**
 * This method is used to send notification to SST user and SST company.
 * The NotificationAPI and UserAPI import is required.
 * @param {Number} companyID - The company ID that will be associated to notification.
 * @param {Number} designUserID - The user ID that will be associated to notification.
 * @param {Number} messageID - The message ID that will be associated to notification.
 * @param {Number} itemID - The item ID that will be associated to notification.
 * @return {Boolean} True if the notification is sent, false if not.
 */
const sendNotification = (companyID, designUserID, messageID, itemID) => {

  UserAPI.getSSO(designUserID)
    .then(response => {

      // console.log('Design User: ', response)

      const user = Array.isArray(response) && response.length > 0 ? response[0] : { id: null }

      NotificationAPI.save(companyID, user.id, messageID, itemID)
        .then(response => {
          // console.log('Notification saved: ', response)
          return true
        })
        .catch(error => {
          console.log(error)
          return false
        })

    })
    .catch(error => {
      console.log(error)
      return false
    })
}

export {
  sendNotification
}

